import { AirshipThemeOption } from '../models';

const coverImageBlue = 'b099f60b-cf3b-4f9b-ba61-ff6e33e8742a';
const coverImageGold = 'fcd9b6aa-cb3a-4e85-8af9-4396d92a16e8';
const coverImageRed = 'fef233e0-2616-4e0a-8c74-d75bab655e3e';

const coverImage1 = '8a4cca60-8b1a-4627-8668-8475b47be7ab';
const coverImage2 = '9f05fd40-020b-43b8-9688-17eb0ec4192a';
const coverImage3 = '5f14c580-d295-4fa8-860e-ab51c68c4db4';
const coverImage4 = '1b8ad7ae-ca41-4add-a6d2-b7c92ae2ed9a';

export const globalCoverImages = [
  coverImage1,
  coverImage2,
  coverImage3,
  coverImage4,
];

export const getDefaultCoverImage = (theme: AirshipThemeOption) => {
  switch (theme) {
    case 'AIRSHIP_BLUE':
      return coverImageBlue;
    case 'AIRSHIP_GOLD':
      return coverImageGold;
    case 'AIRSHIP_RED':
      return coverImageRed;
  }
};
